import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
export function ConversionSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    whatsapp: '',
    destination: '',
    budget: '',
    dates: '',
    notes: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await fetch('https://formsubmit.co/ajax/netaneltoursvip@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          whatsapp: formData.whatsapp,
          destination: formData.destination,
          budget: formData.budget,
          dates: formData.dates,
          notes: formData.notes,
          _subject: `New VIP Trip Request from ${formData.name}`
        })
      });
      if (response.ok) {
        setIsSuccess(true);
        setFormData({
          name: '',
          email: '',
          whatsapp: '',
          destination: '',
          budget: '',
          dates: '',
          notes: ''
        });
      } else {
        alert('Something went wrong. Please try again or contact us via WhatsApp.');
      }
    } catch (error) {
      alert('Something went wrong. Please try again or contact us via WhatsApp.');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="plan-trip" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#1f2933] text-white" data-id="element-1">
      <div className="max-w-3xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4">
            Plan Your Next Trip with VIP Service
          </h2>
          <p className="text-gray-400 text-lg" data-id="element-5">
            Tell us your dream destination and we will create the perfect travel
            plan.
          </p>
        </div>

        {isSuccess ? <div className="bg-white/10 border border-white/20 rounded-lg p-8 text-center animate-fade-in" data-id="element-6">
            <div className="flex justify-center mb-4" data-id="element-7">
              <CheckCircle className="h-16 w-16 text-green-400" data-id="element-8" />
            </div>
            <h3 className="text-2xl font-bold mb-2" data-id="element-9">Request Received!</h3>
            <p className="text-gray-300 mb-6" data-id="element-10">
              Thank you for contacting Netanel Tours VIP. One of our travel
              experts will contact you shortly via WhatsApp.
            </p>
            <button onClick={() => setIsSuccess(false)} className="text-white underline hover:text-gray-300" data-id="element-11">
              Send another request
            </button>
          </div> : <form onSubmit={handleSubmit} className="bg-white rounded-lg p-8 shadow-xl text-[#1f2933]" data-id="element-12">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-13">
              <div data-id="element-14">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-15">
                  Full Name
                </label>
                <input type="text" id="name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50" placeholder="John Doe" data-id="element-16" />
              </div>
              <div data-id="element-17">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-18">
                  Email Address
                </label>
                <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50" placeholder="john@example.com" data-id="element-19" />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-20">
              <div data-id="element-21">
                <label htmlFor="whatsapp" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-22">
                  WhatsApp Number
                </label>
                <input type="tel" id="whatsapp" name="whatsapp" required value={formData.whatsapp} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50" placeholder="+1 234 567 8900" data-id="element-23" />
              </div>
              <div data-id="element-24">
                <label htmlFor="budget" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-25">
                  Estimated Budget
                </label>
                <select id="budget" name="budget" value={formData.budget} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50" data-id="element-26">
                  <option value="" data-id="element-27">Select a range</option>
                  <option value="$1k-3k" data-id="element-28">$1,000 - $3,000</option>
                  <option value="$3k-5k" data-id="element-29">$3,000 - $5,000</option>
                  <option value="$5k-10k" data-id="element-30">$5,000 - $10,000</option>
                  <option value="$10k+" data-id="element-31">$10,000+</option>
                  <option value="Luxury" data-id="element-32">Luxury / No Limit</option>
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-33">
              <div data-id="element-34">
                <label htmlFor="destination" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-35">
                  Preferred Destination
                </label>
                <input type="text" id="destination" name="destination" value={formData.destination} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50" placeholder="e.g. Thailand, Europe..." data-id="element-36" />
              </div>
              <div data-id="element-37">
                <label htmlFor="dates" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-38">
                  Travel Dates
                </label>
                <input type="text" id="dates" name="dates" value={formData.dates} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50" placeholder="e.g. Summer 2026" data-id="element-39" />
              </div>
            </div>

            <div className="mb-8" data-id="element-40">
              <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-41">
                Additional Notes / Preferences
              </label>
              <textarea id="notes" name="notes" rows={4} value={formData.notes} onChange={handleChange} className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-[#4b5563] focus:border-transparent outline-none transition-shadow bg-gray-50 resize-none" placeholder="Tell us about your dream trip..." data-id="element-42"></textarea>
            </div>

            <button type="submit" disabled={isSubmitting} className="w-full bg-[#4b5563] text-white font-bold py-4 rounded-md hover:bg-[#374151] transition-colors flex items-center justify-center disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-43">
              {isSubmitting ? 'Submitting...' : <>
                  Get My VIP Travel Plan <Send className="ml-2 h-5 w-5" data-id="element-44" />
                </>}
            </button>

            <p className="mt-4 text-xs text-center text-gray-400" data-id="element-45">
              By submitting this form, you agree to be contacted via WhatsApp or
              Email.
            </p>
          </form>}
      </div>
    </section>;
}